import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _e242f776 = () => interopDefault(import('../src/pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _064399c6 = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _6505b9cc = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _36dda5fd = () => interopDefault(import('../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _4af4e0c2 = () => interopDefault(import('../src/pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _474ab3e4 = () => interopDefault(import('../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _abbafec6 = () => interopDefault(import('../src/pages/search-booking/index.vue' /* webpackChunkName: "pages/search-booking/index" */))
const _1241eb5a = () => interopDefault(import('../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _b8532b00 = () => interopDefault(import('../src/pages/travel-extras.vue' /* webpackChunkName: "pages/travel-extras" */))
const _21dad31a = () => interopDefault(import('../src/pages/unsupported-browser.vue' /* webpackChunkName: "pages/unsupported-browser" */))
const _8904c336 = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _007353a2 = () => interopDefault(import('../src/pages/manage-booking/modify.vue' /* webpackChunkName: "pages/manage-booking/modify" */))
const _6a504500 = () => interopDefault(import('../src/pages/manage-booking/receipt.vue' /* webpackChunkName: "pages/manage-booking/receipt" */))
const _0fc643b4 = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _59a72741 = () => interopDefault(import('../src/pages/select-extras/product/index.vue' /* webpackChunkName: "pages/select-extras/product/index" */))
const _3aa6b20b = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _54260edc = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cookie-policy",
    component: _e242f776,
    name: "cookie-policy"
  }, {
    path: "/maintenance",
    component: _064399c6,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _6505b9cc,
    name: "manage-booking"
  }, {
    path: "/privacy-policy",
    component: _36dda5fd,
    name: "privacy-policy"
  }, {
    path: "/receipt",
    component: _4af4e0c2,
    name: "receipt"
  }, {
    path: "/search",
    component: _474ab3e4,
    name: "search"
  }, {
    path: "/search-booking",
    component: _abbafec6,
    name: "search-booking"
  }, {
    path: "/terms-and-conditions",
    component: _1241eb5a,
    name: "terms-and-conditions"
  }, {
    path: "/travel-extras",
    component: _b8532b00,
    name: "travel-extras"
  }, {
    path: "/unsupported-browser",
    component: _21dad31a,
    name: "unsupported-browser"
  }, {
    path: "/manage-booking/cancel",
    component: _8904c336,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/modify",
    component: _007353a2,
    name: "manage-booking-modify"
  }, {
    path: "/manage-booking/receipt",
    component: _6a504500,
    name: "manage-booking-receipt"
  }, {
    path: "/manage-booking/update-details",
    component: _0fc643b4,
    name: "manage-booking-update-details"
  }, {
    path: "/select-extras/product",
    component: _59a72741,
    name: "select-extras-product"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _3aa6b20b,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _54260edc,
    name: "index"
  }, {
    path: "/dedicated",
    component: _54260edc,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-index"
  }, {
    path: "/dedicated/search",
    component: _474ab3e4,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-search"
  }, {
    path: "/dedicated/select-extras/product",
    component: _59a72741,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-select-extras"
  }, {
    path: "/dedicated/travel-extras",
    component: _b8532b00,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-travel-extras"
  }, {
    path: "/dedicated/manage-booking/modify",
    component: _007353a2,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-modify"
  }, {
    path: "/dedicated/receipt",
    component: _4af4e0c2,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-receipt"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
